import React from 'react';
import './callpick.css';

const callPick =(props)=>{
    return(
        <div className="container mt-5" style={{fontFamily:"'Open Sans', open-serif"}}>
            <div className="row ">
                <div className="col-12 text-center">
                    <img src="/assests/images/user.png" className="rounded-circle userheight" alt="user"></img>
                </div>
                <div className="col-12 text-center">
                    <p className="mt-2 docname">DR. Meera</p>
                </div>
            </div>
            <div className="row userheight">
            
            </div>
            <div className="row justify-content-center">
                <div className="col-12 text-center">
                    <i className="fas fa-phone-square text-success callicon mr-4"></i>
                    <i className="fas fa-phone-square text-danger callicon"></i>
                </div>
            </div>
        </div>
    )
}

export default callPick;